import React from 'react';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';

import dedicatedTeamAnimation from '@images/animations/dedicatedTeamAnimation.json';
import * as styles from './Header.module.scss';
import Lottie from 'lottie-react';

export const Header: React.FC = () => {
	return (
		<PaddingContainer className="white-bg">
			<WidthContainer>
				<div className="row no-gutters">
					<div className="col-12 col-lg-6 mb-4">
						<h1
							className={classNames(
								styles.header,
								'font-size-large pb-2 mb-3 mt-0'
							)}
						>
							Dedicated Team
						</h1>
						<p className="font-size-sm pr-2 pr-sm-4 pr-md-0">
							The team is selected according to the client&#8217;s defined
							needs. The team is assigned exclusively for full time to your
							project. EMBIQ delivers specialists skilled in different
							technologies and programming languages. We can deliver Frontend,
							Backend, Architecture, UI/UX, and also DevOps and more. Dedicated
							teams work perfectly for Startups, SMEs or Corporates.
						</p>
					</div>
					<div className="col-12 col-lg-6 d-flex justify-content-center align-items-center">
						<Lottie animationData={dedicatedTeamAnimation} loop={true} />
					</div>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
